/* unplugin-vue-components disabled */import script from "./PointBalance.vue?vue&type=script&setup=true&lang=js"
export * from "./PointBalance.vue?vue&type=script&setup=true&lang=js"

import "./PointBalance.vue?vue&type=style&index=0&id=7ccc9d13&lang=scss"

const __exports__ = script;

export default __exports__